(function($) {
  'use strict';

  // Initialize forms
  // =============================================
  function initForms() {

    // Clear placeholder copy
    let inputs = $("input:not([type=checkbox]), textarea");
    let i = 0;
    while (i < inputs.length) {
      $(inputs[i]).attr('data-placeholder', $(inputs[i]).attr('placeholder'));
      i += 1;
    }

    inputs.on('focus', function() {
      $(this).attr('placeholder', '');
    });

    inputs.on('blur', function() {
      $(this).attr('placeholder', $(this).attr('data-placeholder'));
    });



    // Bootstrap selectpicker
    let $selectpicker = $(".selectpicker");
    $selectpicker.selectpicker({
      size: 6,
      dropupAuto: false,
    });
    $selectpicker.selectpicker('render');

    let $insightsSelect = $(".block--insights-landing-page .js-form-item-category select.form-select");
    $insightsSelect.selectpicker({
      size: 6,
      dropupAuto: false,
    });
    $insightsSelect.selectpicker('render');

    let $caseStudySelectProduct = $(".block--case-studies-landing-page [id=ddlProducts]"),
        $caseStudySelectService = $(".block--case-studies-landing-page [id=ddlServices]");
    $caseStudySelectProduct.selectpicker({
      size: 6,
      dropupAuto: false,
    });
    $caseStudySelectProduct.selectpicker('render');
    $caseStudySelectService.selectpicker({
      size: 6,
      dropupAuto: false,
    });
    $caseStudySelectService.selectpicker('render');



    let $formSelect = $(".block-inline-blocktabs-contact-us .form-select");
    $formSelect.selectpicker({
      size: 6,
      dropupAuto: false,
    });
    $formSelect.selectpicker('render');

  }

  initForms();

  // For autocomplete input
  setTimeout( () => {
    initForms();
  }, 100);

  $(document).ajaxComplete(function(event, xhr, settings) {
    initForms();
  });


  // Checkboxes (click) -- Not web form builder
  // =============================================
  function fancyCheckbox(e) {
    e.preventDefault();

    let $label = $(this),
        $labelParent = $label.parent(),
        $labelInput = $label.parent().find("[type=checkbox]");

    if ( $labelParent.hasClass('on') ) {
      $labelParent.removeClass('on');
      $labelInput.attr('checked', false);
    } else {
      $labelParent.addClass('on');
      $labelInput.attr('checked', true);
    }

    $labelInput.trigger('change');
  }

  $(".js-form-type-checkbox-refiner").on('click', 'label', fancyCheckbox);

  // Checkboxes (keyboard control) -- Not web form builder
  // =============================================
  function fancyCheckboxKeypress(e) {
    e.preventDefault();

    if( (e.keyCode ? e.keyCode : e.which) === 13 || (e.keyCode ? e.keyCode : e.which) === 32 ) {
      $(this).trigger('click');
    }
  }

  $(".js-form-type-checkbox-refiner").on('keypress', 'label',  fancyCheckboxKeypress);


  // Checkboxes (on load) -- Not web form builder
  // =============================================
  function checkboxesFromQuery() {

    let $target = $("[type=checkbox]:checked"),
        $targetParent = $target.parents(".js-form-type-checkbox");

    if ( $target.length ) {
      $targetParent.addClass('on');
    }
  }

  setTimeout(function() {
    checkboxesFromQuery();
  }, 100);


  // Checkboxes (remove facet) -- Not web form builder
  // =============================================
  function checkboxesRemoveFacet() {
    $(".checkbox-refiners label").trigger('click');
  }

  $(".js-facet-remove").on('click', checkboxesRemoveFacet);




  // Checkboxes (click) -- web form builder
  // =============================================
  function fancyCheckboxWebform(e) {
    e.preventDefault();

    let $labelWebform = $(this),
        $labelParentWebform = $labelWebform.parent(),
        $labelInputWebform = $labelWebform.parent().find("[type=checkbox]");

    if ( $labelParentWebform.hasClass('on') ) {
      $labelParentWebform.removeClass('on');
      $labelInputWebform .attr('checked', false);
    } else {
      $labelParentWebform.addClass('on');
      $labelInputWebform .attr('checked', true);
    }

    $labelInputWebform .trigger('change');
  }

  // Checkboxes (keyboard control) -- web form builder
  // =============================================
  function fancyCheckboxKeypressWebform(e) {
    e.preventDefault();

    if( (e.keyCode ? e.keyCode : e.which) === 13 || (e.keyCode ? e.keyCode : e.which) === 32 ) {
      $(this).trigger('click');
    }
  }

  // Checkboxes (on load) -- web form builder
  // =============================================
  function checkboxesFromQueryWebform() {

    let $targetWebform = $(".js-form-type-checkbox [type=checkbox]"),
        $targetCheckedWebform = $(".js-form-type-checkbox [type=checkbox]:checked"),
        $targetParentWebform = $targetWebform.parent();

    if ( $targetCheckedWebform.length ) {
      $targetParentWebform.addClass('on');
    }
  }

  $(".js-form-type-checkbox").on('click', 'label', fancyCheckboxWebform);
  $(".js-form-type-checkbox").on('keypress', 'label', fancyCheckboxKeypressWebform);
  checkboxesFromQueryWebform();

  $(window).ajaxComplete(function(event, xhr, settings) {
    $(".js-form-type-checkbox").on('click', 'label', fancyCheckboxWebform);
    $(".js-form-type-checkbox").on('keypress', 'label', fancyCheckboxKeypressWebform);
    checkboxesFromQueryWebform();
  });

  $("[type=checkbox]:disabled").parent().addClass('disabled');

})(jQuery);
